import React from 'react'
import PropTypes from 'prop-types'
import MaskedInput from 'react-text-mask'
import classes from 'classnames'

import { split, concat, values } from 'lodash'

import { ui } from 'parking-react-common'

import FormGroup from '../components/FormGroup'

import './TimePickerInput.css'

function timeMask(value, segments = 3) {
    const chars = split(value, '')
    const hours = [
        /[0-2]/,
        chars[0] === '2' ? /[0-3]/ : /[0-9]/
    ]
    const minutes = [/[0-5]/, /[0-9]/]
    const seconds = [/[0-5]/, /[0-9]/]

    return segments === 3
        ? concat(hours, ':', minutes, ':', seconds)
        : concat(hours, ':', minutes)
}

const TimePickerInput = (props) => {
    const {
        label, input, meta, description, size, segments, isHorizontal, ...otherProps
    } = props
    const { name } = input
    const { error } = meta

    return (
        <FormGroup
            name={ name }
            label={ label }
            error={ error }
            description={ description }
            isHorizontal={ isHorizontal }
        >
            <MaskedInput
                id={ name }
                // keepCharPositions
                className={ classes(
                    'form-control',
                    `input-${size}`,
                    'time-picker-input',
                    `time-picker-${segments}-segments`
                ) }
                mask={ (value) => timeMask(value, segments) }
                { ...otherProps }
                { ...input }
            />
        </FormGroup>
    )
}

TimePickerInput.propTypes = {
    label        : PropTypes.string,
    input        : PropTypes.object,
    meta         : PropTypes.object,
    description  : PropTypes.string,
    size         : PropTypes.oneOf(values(ui.SIZE)),
    segments     : PropTypes.number,
    isHorizontal : PropTypes.bool
}

TimePickerInput.defaultProps = {
    segments     : 3,
    isHorizontal : false
}

export default TimePickerInput
